/* 第三方类库 */
import 'mint-ui/lib/style.css' // mint-ui

// 自定义全局样式
import '@/assets/css/pages/html/layout.css'
import '@/assets/css/pages/common/css.css'
import '@/assets/css/pages/common/global.css'
import '@/assets/css/pages/html/base.css'
//ui样式
import '@/assets/css/components/element/css.css'

import Vue from 'vue'
import App from './App'
import router from './router'
import 'es6-promise/auto'
import axios from 'axios'
import store from './vuex/store'
import * as custom from './api/filter/custom'

// mint-ui
import { Lazyload, Popup } from 'mint-ui'
Vue.use(Lazyload) //mint-ui的延迟加载
// element-ui
import {
  Dialog,
  Table,
  TableColumn,
  Radio,
  Loading,
  Checkbox,
  MessageBox
} from 'element-ui'
Vue.use(Dialog)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service

//自定义组件和js加载
import {
  FyForm,
  FyFormItem,
  FyInput,
  FySelect,
  FyCheckbox,
  FyRadio,
  FyInputDate,
  FyElDate
} from '@/components/form'
import { ImgLazy } from '@/components/lazy'

import defines from './config'
import util from '@/api/utils/util'
import dateUtil from '@/api/utils/dateUtil'
import dataUtils from '@/api/utils/dataUtils'
import domUtils from '@/api/utils/domUtils'
import pageField from '@/api/field'
import sessionStorageUtil from '@/api/sessionStorageUtil'
import localStorageUtil from '@/api/localStorageUtil'
import loadingIndicator from '@/api/loadingIndicator'
import messages from '@/api/messages'
import {
  get,
  post,
  put,
  deletes,
  upload,
  pushByName,
  pushByPath,
  isLogin,
  loginType,
  getDomain,
  getOldWebUrl,
  getWebUrl,
  popupCenter
} from '@/api/base'
import Toast from '@/api/toast'

import { request } from 'https'
import number from '@/api/number.js'

Vue.use(Toast)

//将全局js添加到vue属性中（在vue组件中可以直接this.defines.name访问defines对应js中的属性）
//第三方插件
Vue.prototype.$messageBox = MessageBox
//子定义
Vue.prototype.$number = number
Vue.prototype.$defines = defines //全局配置
Vue.prototype.$util = util
Vue.prototype.$dateUtil = dateUtil //日期js工具
Vue.prototype.$dataUtils = dataUtils //获取数据工具js
Vue.prototype.$domUtils = domUtils //操作dom元素工具js
Vue.prototype.$pageField = pageField //取表单验证规则js工具
Vue.prototype.$sessionStorageUtil = sessionStorageUtil
Vue.prototype.$localStorageUtil = localStorageUtil
Vue.prototype.$loadingIndicator = loadingIndicator //加载中图标
Vue.prototype.$messages = messages //取后端消息js工具
/* 异步请求方式封装 */
Vue.prototype.$myGet = get
Vue.prototype.$myPost = post
Vue.prototype.$myPut = put
Vue.prototype.$myDeletes = deletes
Vue.prototype.$myUpload = upload
Vue.prototype.$pushByName = pushByName //name路由跳转
Vue.prototype.$pushByPath = pushByPath //path路由跳转
Vue.prototype.$isLogin = isLogin //判断是否登陆
Vue.prototype.$loginType = loginType //获取登陆类型
Vue.prototype.$getDomain = getDomain //获取域名
Vue.prototype.$getOldWebUrl = getOldWebUrl //获取旧网站项目地址(如：http://visa.fengye.cc:9999)
Vue.prototype.$getWebUrl = getWebUrl //获取当前网站项目地址(如：http://visa.fengye.cc:9191)
Vue.prototype.$popupCenter = popupCenter //弹出子窗口

Vue.config.productionTip = false // 关闭生产模式下给出的提示，另外需要将 NODE_ENV 设置为 production
//Vue.config.debug = true //开启debug模式

Vue.prototype.$axios = axios
axios.defaults.withCredentials = true //允许axios跨域携带cookie信息
axios.defaults.baseURL = process.env.BASE_URL //默认的url前缀

//加载组件(第三方插件)
Vue.component(Popup.name, Popup) //mint-ui的提示框
//加载组件(自定义)
Vue.component('fy-form', FyForm)
Vue.component('fy-form-item', FyFormItem)
Vue.component('fy-input', FyInput)
Vue.component('fy-select', FySelect)
Vue.component('fy-checkbox', FyCheckbox)
Vue.component('fy-radio', FyRadio)
Vue.component('fy-input-date', FyInputDate)
Vue.component('fy-el-date', FyElDate)
Vue.component('img-lazy', ImgLazy)

// 加载全局过滤器
Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js